export const INVENTORY_TAB_INDEX = {
    SUMMARY: 0,
    CATEGORIES: 1,
    SUBCATEGORIES: 2,
    BRANDS: 3,
    GROUPS: 4,
    PRODUCTS: 5,
    DISTRESSED: 6,
    EXPLORER: 7,
};

export const USER_PERMISSIONS = {
    SUPERADMIN: 'superadmin',
    ADMIN: 'admin',
    MANAGER: 'manager',
    USER: 'user'
};

export const isSuperadmin = (auth) => auth?.permissionGroup === USER_PERMISSIONS.SUPERADMIN;

export const INVENTORY_UNDEFINED_LABEL = 'Undefined';